import React, { useEffect, useState, useCallback } from "react";
import { Grid, Button } from "@material-ui/core";
import {  useSelector } from "react-redux";
// import styles from "./setting.module.css";
import CloseIcon from "@mui/icons-material/Close";
import DoneIcon from "@mui/icons-material/Done";
import { ReactComponent as ArrowTag } from '../../utils/assets/ArrowTag.svg';
import { Typography, Box, Snackbar, Alert } from "@mui/material";
import useAxiosPrivate from "../../utils/hooks/useAxiosPrivate";

export default function AccountModalAdmin() {
    const axios = useAxiosPrivate()
     const role = useSelector((state) => state.auth.role);
    const [request, setRequest] = useState(null);
    const [alertSnack, setAlertSnack] = useState({
        showAlert: false,
        severity: "success",
        message: "",
    });
    const [acceptRequest, setAcceptRequest] = useState([])
    const [deniedRequest, setDeniedRequest] = useState([])
    

    const isRestrictedRole = role === "COACH" || role === "USER";

    const loadData = useCallback(async (e) => {
        try {
            const { data } = await axios.get("/actions/list");
            setRequest(data?.data)
        } catch (error) {
            console.log(error);
            if (error.response && error.response?.data) {
                setAlertSnack({
                    showAlert: true,
                    severity: "error",
                    message: error.response?.data?.message,
                });
            } else {
                setAlertSnack({
                    showAlert: true,
                    severity: "error",
                    message: "Something was wrong!",
                });
            }
        }
    }, [axios]);

    useEffect(() => {
        if (!isRestrictedRole) {
            loadData();
        }
    }, [isRestrictedRole, loadData]);

    const submitAccept = async (e) => {
        try {
            await axios.get(`/actions/approval/${e}/true`);
            setAlertSnack({
                showAlert: true,
                severity: "success",
                message: "Request accepted Successfully!",
            });
            setAcceptRequest(item => [...item, e])
            //loadData()
        } catch (error) {
            if (error.response && error.response?.data) {
                setAlertSnack({
                    showAlert: true,
                    severity: "error",
                    message: error.response?.data?.message,
                });
            } else {
                setAlertSnack({
                    showAlert: true,
                    severity: "error",
                    message: "Something was wrong!",
                });
            }
        }
    };

    const submitDecline = async (e) => {
        try {
            await axios.get(`/actions/approval/${e}/false`);
            setAlertSnack({
                showAlert: true,
                severity: "success",
                message: "Request decline Successfully!",
            });
            setDeniedRequest(item => [...item, e])
            //loadData()
        } catch (error) {
            if (error.response && error.response?.data) {
                setAlertSnack({
                    showAlert: true,
                    severity: "error",
                    message: error.response?.data?.message,
                });
            } else {
                setAlertSnack({
                    showAlert: true,
                    severity: "error",
                    message: "Something was wrong!",
                });
            }
        }
    };

    const handleClose = () => {
        setAlertSnack({
            showAlert: false,
            severity: "success",
            message: "",
        })
    };

    return (
        <Grid item xs={12} sm={12} md={12}>
            {/* <p className={styles.adminText} style={{ color: "var(--primary-text-color)" }}>Coach Email Request</p> */}
            <Box
                style={{
                    width: "30.5rem",
                    height: "11rem",
                    overflowY: "auto",
                    overflowX: "none",
                }}
            >{request?.map((item) => {
                return (
                    <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Grid item md={3}>
                            <Typography style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}>
                                {item?.user?.first_name + ' ' + item?.user?.last_name}
                            </Typography>
                        </Grid>
                        <Grid item md={5}>
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="flex-start"
                            >
                                <Grid item md={2} >
                                    <Grid style={{
                                        marginTop: "0.7rem",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis"
                                    }}>
                                        <ArrowTag />
                                    </Grid>
                                </Grid>
                                <Grid item md={10}>
                                    <Typography style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: '0.8rem',
                                        lineHeight: "30px"
                                    }}>
                                        {item?.old_email}
                                    </Typography>
                                    <Typography item style={{
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        fontSize: '0.8rem',
                                        lineHeight: "30px"
                                    }}>
                                        {item?.new_email}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item md={4}>
                            <Grid
                                container
                                alignItems="center"
                                justifyContent="center"
                                style={{ marginTop: "0.1rem", paddingRight: "0.5rem" }}
                            >{acceptRequest?.includes(item?.request_id) ?
                                <Grid item md={12} lg={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Typography item style={{ fontStyle: "normal", fontWeight: "600", fontSize: '1rem' }}>Approved</Typography>
                                </Grid> :
                                deniedRequest?.includes(item?.request_id) ?
                                    <Grid item md={12} lg={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                                        <Typography item style={{ fontStyle: "normal", fontWeight: "600", fontSize: '1rem' }}>Denied</Typography>
                                    </Grid>
                                    :
                                    <>
                                        <Grid item md={6} style={{ display: "flex", justifyContent: "center" }}>
                                            <Button
                                                fullWidth
                                                size="large"
                                                onClick={() => submitDecline(item?.request_id)}
                                                style={{
                                                    fontSize: "0.9rem",
                                                    lineHeight: "1.25rem",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontStyle: "normal",
                                                    width: 65,
                                                    height: 38,
                                                    backgroundColor: "var(--primary-popup-background-color)",
                                                    color: "var(--primary-text-theme-color)",
                                                    textTransform: "none",
                                                    border: "2px solid",
                                                    borderColor: "var(--primary-text-theme-color)",
                                                }}
                                            >
                                                <CloseIcon />
                                            </Button>
                                        </Grid>
                                        <Grid item md={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <Button
                                                fullWidth
                                                size="large"
                                                onClick={() => submitAccept(item?.request_id)}
                                                style={{
                                                    fontSize: "0.9rem",
                                                    lineHeight: "1.25rem",
                                                    fontFamily: "Poppins",
                                                    fontWeight: 500,
                                                    fontStyle: "normal",
                                                    width: 65,
                                                    height: 38,
                                                    backgroundColor: "var(--primary-button-background-color)",
                                                    color: "var(--primary-button-text-color)",
                                                    textTransform: "none",
                                                }}
                                            >
                                                <DoneIcon />
                                            </Button>
                                        </Grid>
                                    </>}
                            </Grid>
                        </Grid>
                    </Grid>
                )
            })}
            </Box>
            <Snackbar
                open={alertSnack.showAlert}
                autoHideDuration={4000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            >
                <Alert
                    severity={alertSnack.severity}
                    onClose={handleClose}
                >
                    {alertSnack.message}
                </Alert>
            </Snackbar>
        </Grid>
    );
}
